<div *ngIf="userActive" style="text-align: center;">
  <p>User Activated Successfully</p>
  <a [routerLink]="['/login']">Click To Login</a>

  <!-- <button><a routerLink='/login'></a>Click To Login</button> -->
</div>
